import React, { Fragment, useEffect, useState, useRef } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import Pricecalculator from './pricecalculator';
import BuyButton from '../Components/BuyButton';
import ProductTierPriceContainer from './ProductsView/ProductTierPriceContainer';
import ShoppingListButton from '../Components/ShoppingListButton';
import ProductChainIcon from './ProductsView/ProductChainIcon';
import StoreList from './StoreList';
import Popup from './Popup';
import { getClickCollectOrgs } from '../Actions/GetClickCollectOrgs.action';
import { updatePreferredClickCollectAddress } from '../Actions/PreferredClickCollectAddress.action';
import { googleAnalytics } from '../Services/googleAnalytics';
import ProductBlockSliderScrollbar from './ProductBlockSliderScrollbar';

const ProductBlockSlider = (props) => {
  const dispatch = useDispatch();
  const products = props.products !== "null" ? JSON.parse(props.products) : [];
  const schemaEnabled = props.disableSchemaMarkup !== true;
  const isrecommendedprice = useSelector((state) => state.recommendedprice.isrecommendedprice);
  const stores = useSelector((state) => state.clickCollectOrgs);
  const hideShoppingList = window.__litium.constants.hideShoppingList;
  const showBuyButtons = window.__litium.constants.showBuyButtons;
  const { hidePrices } = window.__litium.channelConfig;

  const [expandedSpecs, setExpandedSpecs] = useState({});
  const [isOpenStoreList, setOpenStoreList] = useState(false);
  const [store, setStore] = useState(null);
  const [reRender, setReRender] = useState(true);
  const [carouselState, setCarouselState] = useState(null);
  const carouselRef = useRef(null);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [showExpandButton, setShowExpandButton] = useState({});

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1200 }, items: 4 },
    tablet: { breakpoint: { max: 1199, min: 870 }, items: 3 },
    mobile: { breakpoint: { max: 870, min: 610 }, items: 2 },
    smallmobile: { breakpoint: { max: 610, min: 480 }, items: 1, partialVisibilityGutter: 150 },
    xsmallmobile: { breakpoint: { max: 480, min: 0 }, items: 1, partialVisibilityGutter: 50 }
  };

  const getStockIndicator = (stock) => {
    if (stock == 0) return "dot--red";
    if (stock == 1) return "triangle";
    return "dot";
  };

  const descriptionRef = (id) => (el) => {
    if (el && showExpandButton[id] === undefined) {
      const isOverflowing = el.scrollHeight > 46;
      if (isOverflowing) {
        setShowExpandButton(prev => ({ ...prev, [id]: true }));
      }
    }
  };

  const toggleDescription = (id) => {
    setExpandedDescriptions(prev => ({ ...prev, [id]: !prev[id] }));
  };

  useEffect(() => {
    const preffStore = JSON.parse(window.localStorage.getItem("preferedaddress"));
    const clickStore = JSON.parse(window.localStorage.getItem("preferredclickcollectaddress"));

    if (store == null && preffStore && preffStore.productAssortment?.includes("active") && reRender) {
      let streetAddress = preffStore.streetName;
      streetAddress += preffStore.zipCode ? " " + preffStore.zipCode : "";
      streetAddress += preffStore.city ? " " + preffStore.city : "";

      const newStore = {
        organizationId: preffStore.organizationId,
        organizationName: preffStore.companyName,
        email: preffStore.email,
        homePage: preffStore.homePage,
        address: streetAddress,
        productAssortment: preffStore.productAssortment,
        shopName: preffStore.name,
        latitude: preffStore.latitude,
        longitude: preffStore.longitude
      };

      setStore(newStore);
      setReRender(false);
      dispatch(updatePreferredClickCollectAddress(newStore));
    } else if (clickStore) {
      setStore(clickStore);
    }
  }, [isOpenStoreList]);

  useEffect(() => {
    const initCarousel = () => {
      if (carouselRef.current?.state) {
        setCarouselState(carouselRef.current.state);
      }
    };
    initCarousel();
    const timer = setTimeout(initCarousel, 150);
    
    return () => clearTimeout(timer);
  }, [products]);

  const renderProductSpec = (product) => {
    const isExpanded = expandedSpecs[product.Id] === true;
    const specs = product.SpecificationForProductPage?.filter(s => !s.IsArticleNumber && s.Value) || [];
    const visibleSpecs = isExpanded ? specs : specs.slice(0, 2);

    const toggleSpecs = () => {
      setExpandedSpecs((prev) => ({ ...prev, [product.Id]: !isExpanded }));
    };

    return (
      <div className="product__specification specification-wrap">
        <table className="product-table defaulttable">
          <tbody>
            <tr className="product__specification--list">
              <td className="name">{translate('product.shortenedarticlenumber')}</td>
              <td className="value">
                {product.Id}
                {product.HasChildOrIsChild === true && <ProductChainIcon product={product} />}
              </td>
            </tr>
            {visibleSpecs.map((specification, sindex) => (
              <tr className="product__specification--list" key={sindex}>
                <td className="name">{specification.Name}</td>
                <td className="value">{specification.Value}</td>
              </tr>
            ))}
            {specs.length > 2 && (
              <tr>
                <td colSpan="2">
                  <button className={`spec-toggle-btn ${isExpanded ? 'is-expanded' : ''}`} onClick={toggleSpecs}>
                    {isExpanded ? translate('common.showless') : translate('common.showmore')}
                  </button>
                </td>
              </tr>
            )}
            {!hidePrices && (
              <tr className="product__specification--actions">
                <td className="name">{translate(isrecommendedprice ? 'product.rekpris' : 'product.netprice')}</td>
                <td className="value price">
                  <Pricecalculator
                    isauthorized={props.authenticated?.toString()?.toLowerCase() === 'true'}
                    netpricincludingvat={product.NetPriceIncludingVAT}
                    netpriceexcludingvat={product.NetPrice}
                    recommendedpriceexcludingvat={product.RecommendedPrice}
                    recommendedpriceincludingvat={product.RecommendedPriceIncludingVAT}
                    campaignpriceincludingvat={product.CampaignPriceIncludingVAT}
                    campaignprice={product.CampaignPrice}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const renderProduct = (product, index) => {
    const handleOpenPopup = (productId) => {
      setOpenStoreList(true);
      dispatch(getClickCollectOrgs(productId));
    };

    return (
      <div
        key={index}
        itemScope={schemaEnabled ? true : undefined}
        itemType={schemaEnabled ? 'http://schema.org/Product' : undefined}
        className={product.IsExpired ? 'product__wrapper product--expired' : 'product__wrapper'}
      >
        <figure className="product__figure">
          {product.PLCBanner && (
            <span className="plc-status" style={{ backgroundColor: product.PLCBanner.ColorCode }}>
              {product.PLCBanner.Text}
            </span>
          )}
          <a href={product.Url} title={product.Name} tabIndex={-1}>
            <div className="product__figure--img" dangerouslySetInnerHTML={{ __html: product.ImageUrl }} />
          </a>
        </figure>

        <article className="product__info">
          {schemaEnabled && <meta itemProp="description" content={product.Description} />}
          <a href={product.Url} className="product__name--link">
            <h2 itemProp={schemaEnabled ? 'name' : undefined} className="product__name">
              {product.Name}
            </h2>
          </a>
          {props.hidedescription == false && (
            <div className="product__description-container">
              <div 
                ref={descriptionRef(product.Id)}
                className="product__description-grid"
                style={{
                WebkitLineClamp: expandedDescriptions[product.Id] ? "unset" : "2",
                overflow: "hidden",
                minHeight: "46px",
                height: expandedDescriptions[product.Id] ? "auto" : "46px",
              }}
              >
                {product.Description}
              </div>
              {showExpandButton[product.Id] && (
                <button 
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDescription(product.Id);
                  }}
                  className={`spec-toggle-btn ${expandedDescriptions[product.Id] ? 'is-expanded' : ''}`}
                >
                  {expandedDescriptions[product.Id] 
                    ? translate('common.showless') 
                    : translate('common.showmore')}
                </button>
              )}
            </div>
          )}
          {renderProductSpec(product)}
          {!hidePrices && !product.IsExpired && product.Price && product.Price.TierPrices && product.Price.TierPrices.length > 1 && (
            <div className="grid-tier-price">
              <ProductTierPriceContainer product={JSON.stringify(product)} />
            </div>
          )}

          <div className="product__buy">
            {!product.IsExpired && (
              <div>
                <div className={`product__buy--area ${props.isClickAndCollect ? 'easyline__buy--area' : ''}`}>
                  <BuyButton
                    articleNumber={product.Id}
                    minValue={product.Price_Multiple}
                    cssClass={product.EnableBuyButton ? 'button buy-button product__buy-button' : 'button buy-button product__buy-button disabled'}
                    label={translate('button.addtocart')}
                    quantityFieldId=""
                  >
                    <span>
                      <a className="button buy-button product__buy-button">{translate('button.addtocart')}</a>
                    </span>
                  </BuyButton>
                  {!hideShoppingList && (
                    <div className="no-padding shoppinglist-button">
                      <ShoppingListButton
                        productId={product.Id}
                        isSmall={props.isClickAndCollect || showBuyButtons}
                        product={product}
                      />
                      <div className='shoppinglist-tooltip'>{translate('tooltip.addtowishlist')}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {product.ShouldShowStockStatus && props.isClickAndCollect && (
              product.IsInStock ? (
                <div className="product__stock-info-container">
                  {store && store.organizationId ? (
                    <div
                      className="product__stock-info product__stock-info--store"
                      tabIndex={0}
                      onClick={() => handleOpenPopup(product.Id)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') handleOpenPopup(product.Id);
                      }}
                    >
                      <div className={getStockIndicator(store.stock)}></div>
                      <span className="product__stock-info--stock">
                        {store.stock > 0 ? `+${store.stock} ` : `${store.stock} `}
                        {translate('storelist.isinstock')}
                      </span>
                      <span className="product__stock-info--store-name">
                        {store.shopName}
                      </span>
                    </div>
                  ) : (
                    <a
                      className="product__stock-info"
                      title={product.Name}
                      tabIndex={0}
                      onClick={() => {
                        googleAnalytics({ event: 'clickAndCollectOpenStoreSelect' });
                        handleOpenPopup(product.Id);
                      }}
                    >
                      <span className='dot--not-selected'></span>
                      <span className="product__stock-info--textcolor">
                        {translate('product.showstores')}
                      </span>
                    </a>
                  )}
                </div>
              ) : (
                <span className="product__stock-info">
                  {translate('product.isnotinstock')}
                </span>
              )
            )}
          </div>
        </article>
      </div>
    );
  };

  const CustomArrows = ({ next, previous, carouselState }) => {
    return (
      <div className="custom-arrows">
        <button
          className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
          onClick={previous}
          disabled={carouselState?.currentSlide === 0}
        />
        <button
          className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
          onClick={next}
          disabled={carouselState && carouselState.currentSlide + carouselState.slidesToShow >= carouselState.totalItems}
        />
      </div>
    );
  };

  return (
    <Fragment>
      <div className="product-wrap--outer storeList-outer">
        <Popup
          isOpen={isOpenStoreList}
          setOpen={setOpenStoreList}
          component={
            <StoreList
              store={store}
              setStore={setStore}
              stores={stores.organizations}
              closeModal={() => setOpenStoreList(false)}
            />
          }
        />
        <Carousel
          ref={carouselRef}
          responsive={responsive}
          partialVisible={true}
          swipeable={true}
          infinite={false}
          showDots={false}
          arrows={false}
          renderButtonGroupOutside={true}
          customButtonGroup={<CustomArrows carouselState={carouselState} />}
          afterChange={(previousSlide, state) => {
            setCarouselState(state);
          }}
        >
          {products.map((product, index) => (
            <div key={index} className="product-list__item is-slider">
              {renderProduct(product, index)}
            </div>
          ))}
        </Carousel>
        {carouselState && carouselState.totalItems > carouselState.slidesToShow && (
          <ProductBlockSliderScrollbar carouselState={carouselState} />
        )}
      </div>
    </Fragment>
  );
};

export default ProductBlockSlider;